export const ONBOARDING = 'onboarding';
export const ISSUING_AUTHORITY_MAP = 'issuingAuthorityMap';
export const ISSUING_AUTHORITY_DATABASE = 'issuingAuthorityDatabase';
export const VENDOR = 'vendor';
export const VERIFICATION = 'verification';

export const AVAILABLE_LANGUAGES = {
  en: 'en',
  ar: 'ar'
};

export const VERIFIER = 'verifier';

export const DEFAULT_LNG = AVAILABLE_LANGUAGES.en;
export const LANGUAGES = [AVAILABLE_LANGUAGES.en /*AVAILABLE_LANGUAGES.ar*/];
export const DEFAULT_NS = 'common';
export const COOKIE_NAME = 'portalLang';

export const COMMON = 'common';
export const DASHBOARD = 'dashboard';

export const TEAM_MEMBERS = 'teamMembers';
export const VALIDATION = 'validation';
export const SKIP_TASK_BUTTON = 'skipTaskButton';
